import React, { createContext, useContext } from 'react';
import { useAuth } from '../../auth';

interface SuperAdminModeContextType {
  isSuperAdminMode: boolean;
}

const SuperAdminModeContext = createContext<SuperAdminModeContextType>({
  isSuperAdminMode: false,
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function SuperAdminModeProvider({ children }: { children: React.ReactNode }) {
  const { currentUser } = useAuth();
  const isSuperAdminMode = !!currentUser?.data?.user?.role?.isSuperAdmin;

  return (
    <SuperAdminModeContext.Provider value={{ isSuperAdminMode }}>
      {children}
    </SuperAdminModeContext.Provider>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useSuperAdminMode() {
  return useContext(SuperAdminModeContext);
}
